import React from 'react';

const Button = (props) => {
    const {
        id = '',
        handeleOnClick = {},
        displayLabel = '', className = '', type = 'submit',
        onClick = '', subdisplaylabel = '', disabled = false,
        data = ''
    } = props;
    if (type === 'submit') {
        return (
            <button
                data-id={id}
                onClick={handeleOnClick}
                type={type}
                data={data}
                className={className}>
                {displayLabel}
                <span className="sublabel-content">{subdisplaylabel}</span>
            </button>
        );
    }
    return (
        <button
            data-id={id}
            type={type}
            onClick={handeleOnClick}
            className={className}
            disabled={disabled}
            data={data}
            onClick={onClick}
            >
            {displayLabel}
            {props.children}
            <span className="sublabel-content">{`${subdisplaylabel}`}</span>
        </button>
    );
}

export default Button;